import React from 'react';

export function DesktopIcon(): JSX.Element {
  return (
    <svg fill='none' height='18' viewBox='0 0 18 18' width='18' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.75007 3.75H14.2501C14.2501 3.75 15.0578 3.75 15.0578 4.55769V11.0192C15.0578 11.0192 15.0578 11.8269 14.2501 11.8269H3.75007C3.75007 11.8269 2.94238 11.8269 2.94238 11.0192V4.55769C2.94238 4.55769 2.94238 3.75 3.75007 3.75Z'
        stroke='#121516'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.0194 14.25H6.98096L7.3848 11.8269H10.6156L11.0194 14.25Z'
        stroke='#121516'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M5.76904 14.25H12.2306' stroke='#121516' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
